<template>
  <div>
    <Modal v-model="visible" width="1000px" title="业务员" :footer-hide="true" :mask-closable="false" class="my-modal top p-b">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">工号/姓名</span>
          <Input v-model="searchParams.nameOrNo" placeholder="请输入工号/姓名" clearable />
        </div>

        <div class="input-item">
          <span class="label">状态</span>
          <RadioGroup v-model="searchParams.businessStatus" class="status" @on-change="searchAjax()">
            <Radio label="">
              <span>全部</span>
            </Radio>
            <Radio label="1">
              <span>在职</span>
            </Radio>
            <Radio label="2">
              <span>停职</span>
            </Radio>
            <Radio label="3">
              <span>离职</span>
            </Radio>
          </RadioGroup>
        </div>

        <div class="btn-item" v-if="!isDisabled">
          <div class="sync-switch" v-if="rowData.status != -1 && rowData.calculateType != '1'">
            <span class="label">是否同步新业务员</span>
            <i-switch v-model="rowData.syncUserType" :true-value="1" :false-value="0" :before-change="handleBeforeChange">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </div>
        <div class="btn-item" v-else>
          <Button type="primary" class="del-btn" @click="searchAjax">查询</Button>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box" v-if="!isDisabled">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部业务员</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? tableData.length : selectArr.length }}</span
            >项，共<span>{{ tableData.length }}</span
            >个业务员</span
          >
        </div>

        <Button type="primary" class="del-btn" @click="searchAjax">查询</Button>
        <Button
          class="del-btn"
          type="warning"
          v-if="calculateType != 1"
          @click="$refs.addUser.open(formData)"
          :disabled="(status == '-1' && isAllotOrg) || (status == '-1' && tableData.length) ? true : false"
          >新增业务员</Button
        >
        <Button type="primary" ghost class="del-btn" @click="batchDelete" v-if="calculateType != 1" :disabled="status == '-1' ? true : false">批量删除</Button>
      </div>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
          <template slot-scope="{ row }" slot="name">
            <div class="user-box" v-if="row.name">
              <i class="dian" :class="{ 'red': row.businessStatus == 3, 'orange': row.businessStatus == 2 }"></i>
              <span class="user-name">{{ row.name }}</span>
            </div>
          </template>

          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" v-if="calculateType != 1" :class="{ 'disabled': status == '-1' }" @click="del(row)">删除</span>
          </template>
        </Table>
      </div>
    </Modal>

    <!-- 修改基本信息  -->
    <okAddUser ref="addUser" @success="searchAjax(), $emit('success')"></okAddUser>
  </div>
</template>

<script>
import okAddUser from './okAddUser';
import { pageTool, common } from '@/api/mixins';
export default {
  components: {
    okAddUser
  },
  mixins: [pageTool, common],
  props: [],
  data() {
    return {
      status: '',
      calculateType: '',
      visible: false,
      listLoading: false,
      isAllotOrg: null,
      selectArr: [],
      isAll: false,
      isDisabled: false,
      formData: {},
      rowData: {},
      columns: []
    };
  },
  methods: {
    open(data = {}, isDisabled = false) {
      this.status = data.status;
      this.formData.id = data.id;
      this.searchParams.selected = true;
      this.searchParams.businessId = data.id;
      this.calculateType = data.calculateType;
      this.isDisabled = isDisabled;
      this.isAllotOrg = data.isAllotOrg;
      this.rowData = data;
      this.getColumns();
      this.visible = true;
      this.initListAjax('/buz/merchantActivity/queryJoinUserList');
    },
    // 获取表格字段
    getColumns() {
      let columns = [];
      if (!this.isDisabled) {
        columns.push({
          type: 'selection',
          width: 80,
          align: 'center'
        });
      }
      columns = columns.concat([
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: '工号',
          key: 'staffNo',
          align: 'center'
        },
        {
          title: '姓名',
          slot: 'name',
          align: 'center'
        }
      ]);
      if (!this.isDisabled) {
        columns.push({
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '100'
        });
      }
      this.columns = columns;
    },
    // 是否同步新业务员
    handleBeforeChange() {
      return new Promise(resolve => {
        this.$http({
          url: '/buz/merchantActivity/syncUserActivity',
          type: 'POST',
          data: {
            id: this.formData.id,
            syncUserType: this.rowData.syncUserType == 1 ? 0 : 1
          }
        }).then(res => {
          this.$emit('success');
          resolve();
        });
      });
    },

    searchAjax() {
      this.pageNum = 1;
      this.isAll = false;
      this.selectArr = [];
      this.initListAjax('/buz/merchantActivity/queryJoinUserList');
    },

    // 删除
    del(row) {
      this.$notice.inquiry('确定删除该业务员？').then(() => {
        this.$http({
          url: '/buz/merchantActivity/deleteJoinUserList',
          type: 'POST',
          data: {
            businessId: this.searchParams.businessId,
            dateList: [row.id]
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
        });
      });
    },

    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },

    batchDelete() {
      if (!this.selectArr.length && !this.isAll) {
        this.$notice.msg('请至少选择一个业务员');
        return;
      }
      let data = { businessId: this.searchParams.businessId };
      this.$notice.inquiry('确定删除该业务员？').then(() => {
        if (this.isAll) {
          data.dateList = this.tableData.map(item => item.id);
        } else {
          data.dateList = this.selectArr.map(item => item.id);
        }
        this.$http({
          url: '/buz/merchantActivity/deleteJoinUserList',
          type: 'POST',
          data
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tools-box {
  margin-top: 10px;
  justify-content: flex-start;
}
.search-box {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  overflow: hidden;
  .input-item {
    width: 30%;
    min-width: 240px;
    display: flex;
    margin-bottom: 15px;
    align-items: center;
    .label {
      font-size: 13px;
    }
    /deep/ .ivu-input {
      font-size: 13px;
    }
    /deep/ .ivu-select-selected-value {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 1330px) {
    .input-item {
      width: 50%;
    }
  }
  .btn-item {
    display: flex;
    margin-left: auto;
    align-items: center;
    .reset-btn {
      background-color: #fff;
      color: #236dff;
      border: 1px solid #236dff;
      margin-left: 10px;
    }
    .sync-switch {
      display: flex;
      align-items: center;
      .label {
        margin-right: 10px;
      }
    }
  }
}
.detail span {
  font-size: 13px;
}
/deep/ .user-box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 22px;
  .dian {
    display: block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    &.red {
      background: #e3461f;
    }
  }
  &.text {
    color: #515c6f;
  }
  .user-name {
    font-size: 13px;
  }
  i {
    color: #bababa;
    font-size: 13px;
  }
}
.del-btn {
  margin-left: auto;
}
</style>
